// import polyfills
import "intersection-observer";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "unfetch/polyfill";
import "@ottatech/design/global-styles.css";

import * as Sentry from "@sentry/browser";
import { createRoot } from "react-dom/client";
import { StrictMode } from "react";

import "./i18n";

import { App } from "./App";
import * as serviceWorker from "./serviceWorker";

import { Providers } from "providers";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://263e844d61fa4474919be680a8721a3a@sentry.io/1520260",
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications.",
      "Non-Error exception captured with value: Object Not Found Matching Id:",
      "Non-Error promise rejection captured with value: Object Not Found Matching Id:",
    ],
    allowUrls: [/https?:\/\/((app)\.)?otta\.com/],
    denyUrls: [
      // Chrome extensions
      /^chrome:\/\//i,
    ],
  });
}

const root = createRoot(document.getElementById("root") as Element);

root.render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
